<template>
  <va-modal
    :value="isOpen"
    size="large"
    id="confirmMergeDetailsModal"
    ref="confirmMergeDetailsModal"
    @cancel="onCancel"
    @ok="onConfirm"
    :ok-text="$t('modals.buttons.yes')"
    :cancel-text="$t('modals.buttons.no')"
  >

    <div slot="header">
      <span class="modal-title">{{ $t('clinical.people.merge.modal_title') }}</span>
    </div>

    <section v-if="isLoading" class="text-center py-5">
      <span class="is-bold">{{$t('loading.message')}}</span>
    </section>

    <section v-else-if="person" class="p-3">
      <span >{{$t('clinical.people.merge.modal_body')}}</span>
      <br/>
      <PersonInfo
        v-if="person"
        class="mb-5"
        :person="person"
      />
    </section>

  </va-modal>
</template>

<script>
import PersonInfo from '@/components/clinical/people/PersonDetails/PersonInfo'

export default {
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  components: {
    PersonInfo,
  },
  data: function () {
    return {
      isOpen: false,
      isLoading: false,
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modal-canceled')
      }, 500)
    },
    onConfirm: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modal-confirmed')
      }, 500)
    },
  }
}
</script>
